import { Button } from "primereact/button"
import { useNavigate } from "react-router-dom";
import { BiLogOutCircle } from "react-icons/bi";

export type HeaderType = {
    title: string,
    subtitle: string,
    icon: JSX.Element
}

type Props = {
    // children: React.ReactNode
    title: string
    subtitle: string
    icon: React.ComponentType
    // header: HeaderType
    showReturn?: boolean
}

const Title = ({ title, subtitle, icon: IconComponent, showReturn }: Props) => {
    const navigate = useNavigate()
    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <div style={{ marginLeft: 20 }}></div>
                        <IconComponent />
                        <div style={{ marginRight: 10 }}></div>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {title}
                            <div style={{ fontSize: 16, fontWeight: 'normal', marginTop: -5 }}>{subtitle}</div>
                        </div>
                    </div>
                </div>
                {showReturn && <Button icon={<BiLogOutCircle size={24} />} outlined severity="danger" onClick={() => navigate('/')}></Button>}
            </div>
            <div style={{ width: '100%', borderColor: '#ddd', border: 1, borderStyle: 'solid', marginTop: 10 }} />
        </>
    )
}
export default Title